import { render, staticRenderFns } from "./CrmDatepicker.vue?vue&type=template&id=2185be29&lang=pug"
import script from "./CrmDatepicker.vue?vue&type=script&lang=js"
export * from "./CrmDatepicker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports